

export default {
  SET_ABOUT(state, payload){
    state.about = payload
  }
}
